import type { UseQueryResult } from '@tanstack/react-query';
import { useBasicQuery } from '@hooks/requests/utils/use_basic_query';
import { PARTNER_TEAM_ROLES_PATH } from '@hooks/requests/utils/paths';

/**
 * One role the caller may assign to a team member, as returned by
 * `GET /api/v1/partner/team/roles` — always the caller's own family
 * (BR-002), never the other one.
 */
export interface AssignableRole {
  name: string;
}

export interface UsePartnerTeamRolesParams {
  enabled?: boolean;
}

export const usePartnerTeamRolesQuery = ({
  enabled = true,
}: UsePartnerTeamRolesParams = {}): UseQueryResult<AssignableRole[], Error> =>
  useBasicQuery<AssignableRole[]>(PARTNER_TEAM_ROLES_PATH, undefined, { enabled });

export default usePartnerTeamRolesQuery;
